import React from "react";
import clsx from "clsx";
import useStyles from "./LabNotFoundStyles";

const LabNotFound: React.FC = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={clsx(classes.content, "LEAP-accessDenied-label-container")}>
        <h1 className={classes.headline}>Laboratories not found</h1>
        <div className={classes.message}>
          It seems that you do not have any managed laboratories
          <br /> for the requested page.
        </div>
      </div>
    </div>
  );
};

export default LabNotFound;
